import { createEnum } from "@redotech/zod-util/zod-enum";

export const FulfillmentGroupReassignmentReason = {
  crossBorder: "cross_border",
  insufficientInventory: "insufficient_inventory",
  damagedInventory: "damaged_inventory",
  other: "other",
} as const;

export type FulfillmentGroupReassignmentReason =
  (typeof FulfillmentGroupReassignmentReason)[keyof typeof FulfillmentGroupReassignmentReason];

export const FulfillmentGroupReassignmentReasonSchema = createEnum(
  FulfillmentGroupReassignmentReason,
  { enumName: "FulfillmentGroupReassignmentReason" },
);

export const FulfillmentGroupReassignmentReasonLabels: Record<
  FulfillmentGroupReassignmentReason,
  string
> = {
  [FulfillmentGroupReassignmentReason.crossBorder]: "Cross border",
  [FulfillmentGroupReassignmentReason.insufficientInventory]:
    "Insufficient inventory",
  [FulfillmentGroupReassignmentReason.damagedInventory]: "Damaged Inventory",
  [FulfillmentGroupReassignmentReason.other]: "Other",
};
